import {NgClass, NgTemplateOutlet} from '@angular/common';
import {Component, computed, input, Input} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {ImageLink} from 'shared/pretty-easy-navigation/models';

@Component({
    selector: 'app-pretty-easy-image-link',
    imports: [
        MatIconModule,
        TranslateModule,
        NgClass,
        RouterLink,
        RouterLinkActive,
        MatTooltipModule,
        NgTemplateOutlet,
    ],
    templateUrl: './pretty-easy-image-link.component.html',
    styleUrl: './pretty-easy-image-link.component.scss'
})
export class PrettyEasyImageLinkComponent {
    @Input() isSidebarFolded: boolean;
    public linkData = input<ImageLink>();
    public link = computed(() => this.linkData().link);
    public label = computed(() => this.linkData().label);
    public icon = computed(() => this.linkData().icon);
    public src = computed(() => this.linkData().src);
    public alt = computed(() => this.linkData().alt);
    public queryParams = computed(() => this.linkData().queryParams);
    public fragment = computed(() => this.linkData().fragment);
    public action = computed(() => this.linkData().action);
    public routerLink = computed(() => this.link()?.startsWith('/') ? this.linkData().link : undefined); // Ouais c'est pas terrible link.link
    public href = computed(() => this.link()?.startsWith('/') ? undefined : this.linkData().link);

    public formattedClasses = computed(() => {
        const classes = [
            ...this.linkData().classes || []
        ];

        return classes;
    });

    public onClick(event: MouseEvent): void {
        this.action()?.(event);
    }
}
